
const config = {
  apiOrigin: 'https://email.wasya.co',

  keycloak_url: 'https://auth.wasya.co',
  keycloak_realm: 'wco',
  keycloak_client_id: 'wco',
  skip_keycloak: false,

}
export default config
